<template>
  <div class="p-the-l01-news-list">
    <ul class="p-the-l01-news-list__list">
      <li
        v-for="(news, key) in whatsNewList"
        :key="key"
        class="p-the-l01-news-list__list__panel"
      >
        <a
          v-touch:tap
          :href="urlWhatsNewDetail + '?id=' + news.pk"
          class="p-the-l01-news-list__list__panel__link"
        >
          <p class="p-the-l01-news-list__list__panel__title" data-translate-skip>
            {{ news.title }}
          </p>
          <div class="p-the-l01-news-list__list__panel__info">
            <div class="p-the-l01-news-list__list__panel__info__item">
              掲載日時：{{ customDateFormat(news.start_showing) }}
            </div>
            <div class="p-the-l01-news-list__list__panel__info__item">
              更新日時：{{ customDateFormat(news.updated_at) }}
            </div>
            <div class="p-the-l01-news-list__list__panel__info__item">
              作成者：<span data-translate-skip>{{ news.author_name }}</span> (ID:
              {{ news.employeeId }})
            </div>
          </div>
        </a>
      </li>
    </ul>
    <template v-if="showPageNavi">
      <div class="p-the-l01-news-list__footer">
        <PageNavi
          :current-page="currentPage"
          :max-page="maxPage"
          :next-page-url="nextPageUrl"
          :prev-page-url="prevPageUrl"
          :base-url="baseUrl"
          :search="searchKeyword"
        />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CONST_DATA from "@/general/mixins/const/constData";
import { WhatsNewDetailsModel } from "@/general/store/models";
import dayjs from "dayjs";

@Options({
  props: {
    newsList: { type: Array, required: true },
    pageNavi: { type: Object, required: true },
    searchKeyword: { type: String, required: true },
    slug: { type: String, required: true }
  },
  methods: {
    customDateFormat(value: string) {
      return dayjs(value.split("T")[0])
        .locale("ja")
        .format("YYYY-MM-DD");
    }
  }
})
export default class TheL01NewsList extends Vue {
  newsList!: [];
  pageNavi!: any;
  searchKeyword!: string;
  slug!: string;

  get showPageNavi() {
    return this.pageNavi.maxPage > 1;
  }
  get currentPage() {
    return this.pageNavi.currentPage;
  }
  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }

  get urlWhatsNewDetail() {
    return CONST_DATA.SITE_MAP.WHATS_NEW_DETAILS;
  }

  get whatsNewList(): Array<WhatsNewDetailsModel> {
    return this.newsList.map((w: WhatsNewDetailsModel) => ({
      pk: w.pk,
      title: w.title,
      message: w.message,
      created_at: w.created_at,
      updated_at: w.updated_at,
      author: w.author,
      author_name: w.author_name,
      employeeId: w.employeeId,
      page_details: w.page_details,
      start_showing: w.start_showing
    }));
  }
}
</script>

<style lang="scss" scoped>
.p-the-l01-news-list {
  &__count {
    @include text__body--m;
    font-weight: bold;
    display: block;
  }

  &__list {
    word-break: break-word;

    &__panel {
      border-bottom: px(1) solid $common-gray-border;

      &__link {
        display: block;
        padding: rem(16) 0 rem(8);

        @include sp {
          padding: rem(16) 0;
        }
      }

      &__title {
        color: #4f4f4f;
        line-height: rem(20);
      }

      &__info {
        display: flex;
        margin-top: rem(4);

        @include sp {
          display: block;
        }

        &__item {
          @include text__body--s;
          color: #828282;
          margin-right: rem(24);
          line-height: rem(20);

          @include sp {
            @include text__body--xs;
            margin-right: 0;
            line-height: rem(18);
          }
        }
      }
    }
  }

  &__footer {
    margin-top: rem(40);
  }
}
</style>
